module.exports = __webpack_public_path__ + "static/media/GAIL_F1.fc993d72.txt";